import React , {useState, useEffect, useContext} from "react";
import { useNavigate, Link } from "react-router-dom";
import {useCookies} from "react-cookie";
import { ArgContext } from "../../Context/ArgProvider"
import instance from "../../axios_interceptor.js";

function MobileTest() {

    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

    // 전역변수 불러오기
    const {argInfo, setArgInfo} = useContext(ArgContext);

    // 쿠키 객체
    const [cookies, setCookie, removeCookie] = useCookies(["loggedIn"]);
    
    // 로그인 정보 data
    const [loginInfo, setLoginInfo] = useState({
          userId: ""
        , userPw: ""
    });
    
    
    const [selectedFiles, setSelectedFiles] = useState([]);
    

    // 로딩 후 최초 한번
    useEffect(()=> {
        // 아이디 쿠키 저장 여부 확인 후 set
        if(cookies.loggedIn!=null) {
            // 아이디가 있을 경우 set
            if(cookies.loggedIn!="") {
                setLoginInfo({userId:cookies.loggedIn});
            } 
            // 아이디가 없을 경우 쿠키 삭제
            else {
                removeCookie("loggedIn"); 
            }
        }
    }, []);
    
    const test = () => {
		if (window.native) {
			window.native.showToast('테스트 메시지 입니다.');
		} else {
			alert('앱에서만 동작합니다.');
		}
	};
	
	const onFileChange = (event) => {
		setSelectedFiles(event.target.files);
	};
    
	const rendering = () => {
		const elements = [];
		let cnt;
		try {
			cnt = selectedFiles.length;
		} catch(e) {
			cnt = 0;
		}
		for (let i = 0 ; i < cnt ; i++) {
			elements.push(<span key={'img' + i}>{selectedFiles[i].name}<br/></span>);
		}
		
		if (cnt > 0) {
			const fileReader = new FileReader();
			fileReader.onload = (event) => {
	            const contents = event.target.result;
	            console.log("성공");
	            console.log(contents); // 파일 내용 출력
			};
			
	        const file = selectedFiles[0];
	        fileReader.readAsBinaryString(file);
			
		}
		
		return elements;
	};

    return (
        <>
        	<div>
				<div>
	        		<button onClick={test}>테스트 버튼</button>
	        		<input type='file' capture='camera' multiple onChange={onFileChange} accept='image/*' />
	   			</div>
	   			<div>
	   				{rendering()}
	   			</div>
   			</div>
        </>
    );
}

export default MobileTest;